<template>
  <div style="display: flex;justify-content: space-between">
      <div class="img-preview" v-if="showPreview">
        <div  class="img-preview-content" style="position: relative" v-for="item in previewDataV"
             @mouseenter="item.showDelete = true" @mouseleave="item.showDelete = false">
          <img :src="item.url" alt="">
          <div
              style="position:absolute;width:100%;height:100%;background-color: rgba(0,0,0,0.65); line-height: 75px;color:white;text-align: center"
              v-if="item.showDelete">
            <a-tooltip title="删除">
              <a-icon type="delete" style="cursor: pointer" @click="deleteItem(item)"></a-icon>
            </a-tooltip>
          </div>
        </div>

        <div class="upload-content" @click="showModal = true" v-if="previewData.length < (multiple ? 4 : 1)">
          <a-icon type="plus"/>
        </div>
      </div>
    <a-modal
        title="素材库"
        :visible="showModal"
        :confirm-loading="confirmLoading"
        @ok="save"
        @cancel="cancel"
        width="1300px"
        style="border-radius: 8px"
        :zIndex="10000"
    >
      <a-spin :spinning="spinning" >
        <a-icon
            slot="indicator"
            type="loading"
            style="font-size: 24px; color: var(--main-color)"
            spin
        />
        <div style="width: 100%;display: flex;grid-gap: 20px">
          <div style="width: 200px">
            <a-tree
                v-if="!!tagsList.length"
                :defaultExpandAll="true"
                :defaultSelectedKeys="defaultSelectedKeys"
                :tree-data="tagsList"
                
                style="width: 100%"
                :replaceFields="{
                  children: 'children',
                  title: 'tag_name',
                  key: 'tag_id',
                  value: 'tag_id'
                }"
                @select="toSearch"
            >
            </a-tree>
          </div>
          <div style="flex: 1;">
            <div v-if="!!materialList.length" class="image-content">
              <div class="img-container" v-for="(item) in materialList" :key="item.id">
                <div class="img-main">
                  <img :src="item.m_url || item.img_url" alt="" @click="onChange(item)">
                  <a-checkbox class="img-check" :checked="item.isSelect" @change="onChange(item)"></a-checkbox>
                </div>
                <div class="img_name" :title="item.m_name_cn">{{ item.m_name_cn }}</div>
              </div>
            </div>
            <a-empty v-else/>
          </div>
        </div>
      </a-spin>
      <my-pagination
          ref="MyPagination"
          @change="searchData"
          :total="totalCount"
          v-if="tag_level_id"
      ></my-pagination>
    </a-modal>
  </div>
</template>

<script>
const option = [
  {
    key: '饮品',
    value: 'beverage'
  },
  {
    key: '汉堡',
    value: 'hamburger'
  },
  {
    key: '早餐',
    value: 'breakfast'
  },
  {
    key: '套餐',
    value: 'setMeal'
  },
  {
    key: '小食',
    value: 'refreshment'
  },
  {
    key: '甜品',
    value: 'sweet'
  },
  {
    key: '炸鸡',
    value: 'nuggets'
  },
  {key: '图片背景', value: 'bg'},
  {key: 'logo', value: 'logo'}
]

import materialLibrary from "../../../interface/pages/material/materialLibrary";
import utils from "@/utils";
import MyPagination from "@/components/MyPagination";
import materialCard from "./materialCard";
import materialTagManagement from "@/interface/pages/material/materialTagManagement";

export default {
  name: "uploadImg",
  components: {
    MyPagination,
    materialCard
  },
  props: {
    ...['value'],
    multiple: {
      type: Boolean,
      default: true
    },
    rootID: {
      type: Number,
      default: -1
    },
    currentStep: {
      type: Number,
      default: 1
    },
    showPreview:{
      type:Boolean,
      default:true
    }
  },
  emits: ['input', 'initStep', 'previewDataChange'],
  data() {
    return {
      showDelete: false,
      spinning: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 6
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 16
      },
      showModal: false,
      confirmLoading: false,
      tagsList: [],
      categoryData: [],
      totalCount: 6,
      materialList: [],
      checkedList: [],
      previewData: [],
      previewDataV: [],
      tag_level_id: null,
      curSpecies: null,
      materialType: null,
    }
  },
  methods: {
    showModalTest(type){
      if(!!this.materialType && this.materialType !== type){
        this.materialList = [];
        this.materialType=type
        this.searchData()
      }else{
        this.materialType=type
      }
      this.showModal = true;
    },
    handleCancel() {
      this.showModal = false;
    },
    handleOk() {
      this.showModal = false;
    },
    handleChange(value) {
      this.previewData = value
    },
    handleChangeV(value) {
      this.previewDataV = value
    },
    handleChangeTag(value) {
      this.tag_level_id = value
    },
    handleChangeSpecies(value) {
    },
    initPreviewData() {
      this.previewData = []
      this.previewDataV = []
    },
    deleteItem(item) {
      this.previewData = this.previewData.filter(i => i.id !== item.id)
      this.previewDataV = this.previewDataV.filter(i => i.id !== item.id)
      this.backData = this.multiple ? this.previewData : null
    },
    toSearch(v, e) {
      // this.tagsList.forEach(item=>)
      const item = this.tagsList[0].children.find(i => i.tag_id === v[0])
      if(this.rootID !== -1){
        const obj = option.find(i => i.key === item.tag_name)
        this.curSpecies = obj.value
      }
      this.tag_level_id = v[0] ? v[0] : this.rootID
      this.$refs.MyPagination.initCurrent()
      this.searchData()
    },
    onChange(i) {
      const flag = i.isSelect
      if (!this.multiple) {
        this.materialList.forEach(item => item.isSelect = false)
      }
      if (this.checkedList.length < 4) {
        i.isSelect = !flag;
        const obj = this.checkedList.find(item => item.m_id === i.m_id)
        if (!obj && i.isSelect) {
          if (!this.multiple) {
            this.checkedList = []
          }
          this.checkedList.push(JSON.parse(JSON.stringify(i)))
        }
        if (obj && !i.isSelect) {
          this.checkedList = this.checkedList.filter(item => item.m_id !== i.m_id)
        }
        this.checkedList = this.checkedList.filter(item => item.isSelect)
      } else {
        i.isSelect = false
        this.checkedList = this.checkedList.filter(item => item.m_id !== i.m_id)
        if (this.checkedList.length === 4) {
          this.$message.error('已超出素材数量上限')
        }
      }

    },
    async searchData() {
      this.spinning = true
      const {data: res} = await materialLibrary.getTableData(this, {
            params: {
              current:this.$refs.MyPagination.pagination.curPage,
              size:this.$refs.MyPagination.pagination.pageSize,
              tag: this.tag_level_id,
              type:this.materialType
            },
          })
      ;
      if (res.code === "200") {
        this.materialList = res.data.map((item) => ({
          ...item,
          isSelect: this.checkedList.find((i) => i.id === item.id)
              ? this.checkedList.find((i) => i.id === item.id).isSelect
              : false,
          species: this.curSpecies
        }));
        this.totalCount = res.totalCount;
      } else {
        this.materialList = [];
        this.checkedList = []
        this.$message.error(res.message);
      }
      this.spinning = false
    },
    async getTagsList() {
      const {data: res} = await materialTagManagement.getTagData(this, {
        params: {
          parent_id: this.rootID > 0 ? this.rootID : '',
          if_trending : 1
        },
      });
      this.spinning = false;
      if (res.code === "200") {
        let obj = null
        let arr = []
        if (res.data.length) {
          res.data.forEach(item => {
            const index = arr.findIndex(i => i.id === item.parent_id)
            if (index > -1) {
              const iIndex = arr[index].children.findIndex(i=>i.id === item.id)
              if(iIndex === -1){
                arr[index].children.push(item)
              }
            } else {
              arr.push({
                id: item.parent_id,
                tag_id: item.parent_id,
                tag_name: item.parent_name,
                disabled: true,
                children: [item]
              })
            }
          })
          if(this.rootID !== -1){
            const obj = option.find(i => i.key === res.data[0].tag_name)
            this.curSpecies = obj ? obj.value : null
          }
        }
        this.tagsList = arr;
      } else {
        this.tagsList = [];
        this.$message.error(res.message);
      }
    },
    save() {
      let arr = this.checkedList.map(item => {
        return {
          url: item.m_url || item.img_url,
          species: item.species,
          id: item.id,
          showDelete: false,
          name:item.m_name_cn
        }
      })
      this.previewDataV = JSON.parse(JSON.stringify([...arr]))
      this.previewData = [...arr]
      this.backData = this.multiple ? arr : arr.pop()
      this.showModal = false
      this.$emit('initStep', this.currentStep)
    },
    cancel() {
      this.showModal = false
      this.checkedList = this.checkedList.filter(item => {
        if (this.previewData.find(i => item.id === i.id)) {
          return item
        }
      })
      this.materialList = this.materialList.map(item => {
        item.isSelect = !!this.previewData.find(i => item.id === i.id)
        return item
      })
    },
  },

  mounted() {
    utils.languageChange(this, {labelCol: 6, wrapperCol: 18}, {labelCol: 6, wrapperCol: 18})
  },
  watch: {
    showModal(v) {
      v && this.getTagsList()
    },
    previewData: {
      handler(v) {
        this.materialList.forEach(item => item.isSelect = false)
        this.materialList = this.materialList.map(item => {
          let obj = v.find(i => item.id === i.id)
          if (obj) {
            item.isSelect = true
          }
          return item
        })
        let arr = [...this.checkedList]
        this.checkedList.forEach(item => {
          if (!v.find(i => i.id === item.id)) {
            arr = arr.filter(j => j.id !== item.id)
          }
        })
        this.checkedList = [...arr]
        this.$emit('previewDataChange', this.currentStep)
      },
      deep: true
    }
  },
  computed: {
    backData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    defaultSelectedKeys() {
      if(!!this.tag_level_id){
        return [this.tag_level_id]
      }
      this.tag_level_id = this.tagsList[0].children[0].tag_id
      return [this.tagsList[0].children[0].tag_id]
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-modal-title {
  text-align: left;
  color: var(--main-color);
}

::v-deep .ant-modal-content {
  border-radius: 8px;
}

::v-deep .ant-modal-body {
  padding: 24px;
}

.image-content {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 24px;

  .img-container {
    width: calc(calc(100% - 72px) / 4);
    height: 280px;

    .img_name {
      width: 100%;
      text-align: center;
      padding: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden
    }

    .img-main {
      border: 1px solid #DCDCDC;
      border-radius: 8px;
      width: 100%;
      height: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;

      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 8px;
        cursor: pointer;
      }

      .img-check {
        position: absolute;
        top: 16px;
        right: 16px;
        border-radius: 50%;
        display: inline-block;

        ::v-deep .ant-checkbox-checked::after {
          border: none;
        }

        ::v-deep .ant-checkbox-checked > .ant-checkbox-inner {
          background-color: var(--main-color);
          border-color: var(--main-color);
        }

        ::v-deep .ant-checkbox-inner {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border-color: #ccc;
        }

        ::v-deep .ant-checkbox-inner::after {
          width: 8px;
          height: 15px;
        }
      }
    }
  }
}

.img-preview {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  grid-gap: 6px;
  padding: 10px 0;
  user-select: none;

  .upload-content {
    width: 75px;
    height: 75px;
    text-align: center;
    line-height: 75px;
    border: 1px dashed #ccc;
    cursor: pointer;
  }

  &-content {
    width: 75px;
    height: 75px;
    flex-shrink: 0;
    white-space: nowrap;
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
